import { get } from "../methods";
function getMarketIndustry_default(market) {
  return get({
    url: `api/industry/market${market && market !== "global" ? `/${market}` : ""}`
  });
}
export {
  getMarketIndustry_default as default
};
